import { render, staticRenderFns } from "./InvoiceViewAccordionTable.vue?vue&type=template&id=45275f10&scoped=true"
import script from "./InvoiceViewAccordionTable.vue?vue&type=script&lang=js"
export * from "./InvoiceViewAccordionTable.vue?vue&type=script&lang=js"
import style0 from "./InvoiceViewAccordionTable.vue?vue&type=style&index=0&id=45275f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45275f10",
  null
  
)

export default component.exports